<template>
 <div class="blog-detail">
   <div class="container-fluid">
     <sidebar />
     <div class="col-md-9 col-lg-10 ml-md-auto">
       <div id="scroll" class="header d-flex justify-content-start w-100 align-items-center py-3 mb-5 border-bottom border-dark">
         <h2 class="my-3">ブログ編集</h2>
       </div>
      <div v-if="apiStatus">
        {{statusAlert()}}
      </div>

      <div v-show="error" class="validation py-3 px-5 my-4">
        <p class="m-0">{{ error }}</p>
      </div>
       <div class="edit-blog-form mb-4" v-if="blogList">
         <b-container fluid class="p-0">
           <b-form>
            <div class="bg-light p-4 border mb-3">

              <b-row class="align-items-center d-flex mb-3">
                <b-col lg="2">
                  <label class="required">管理用タイトル</label>
                </b-col>
                <b-col lg="10">
                  <b-form-input v-model="$v.blogList.administrative_title.$model" class="form-input" value="エクセルシオール 川崎古川町" :state="validateState('administrative_title')"></b-form-input>
                  <b-form-invalid-feedback :state="validateState('administrative_title')">
                    <p v-if="!$v.blogList.administrative_title.required">管理用タイトルは必須です</p>
                    <p v-if="!$v.blogList.administrative_title.minLength">管理用タイトルは{{$v.blogList.administrative_title.$params.minLength.min}}文字以上入力してください</p>
                  </b-form-invalid-feedback>
                </b-col>
              </b-row>

              <b-row class="align-items-center d-flex">
                <b-col lg="2">
                  <label>カテゴリ</label>
                </b-col>
                <b-col lg="4">
                  <b-form-select v-model="blogList.category" :options="category" class="form-select"></b-form-select>
                </b-col>
              </b-row>
              <b-row class="my-3 align-items-center d-flex" v-if="blogList">
                <b-col lg="2">
                  <label class="m-0 required">アイキャッチ画像</label>
                </b-col>
                <b-col lg="10" v-if="blogList.blog_images">
                  <b-form-file accept=".jpg, .png, .gif" v-model="blogImage" @change="updateImage" :placeholder="imageUrl"></b-form-file>
                </b-col>
                <b-col lg="10" v-else>
                  <b-form-file v-model="blogList.image" accept=".jpg, .png, .gif" placeholder="ファイルを選択してください" @change="updateImage" :state="validateBlogImageState"></b-form-file>
                  <b-form-invalid-feedback :state="validateBlogImageState">
                    <p v-if="!$v.blogImage.required">アイキャッチ画像は必須です</p>
                  </b-form-invalid-feedback>
                </b-col>
              </b-row>
            </div>

            <div class="accordion p-3 bg-light" role="tablist" v-for="(item, index) in blogList['blog_articles_details']" :key="index">
              <b-card no-body>
                <b-card-header class="main-bg d-flex align-items-center justify-content-between" role="tab">
                  <h4 v-b-toggle="index">
                    {{index}}
                    <span class="h-100 ml-3"><b-icon icon="pencil-fill" scale="1" v-show="blogList.blog_categories[item['language']] !== 'published' && item.title !== null"></b-icon></span>
                  </h4>
                  <div class="d-flex align-items-center">
                    <label class="m-0 h-100 d-flex align-items-center px-4 label-check"><b-form-checkbox :checked="blogList.blog_categories[item['language']] === 'published' ? true: false" @change="selectLanguage(index, $event)" size="lg"></b-form-checkbox>公開</label>
                    <b-button variant="light" v-b-toggle="index" block class="bg-transparent border-0 mr-0 w-auto h-100 px-4">
                      <span class="main-bg h-100 align-items-center d-flex icon"><b-icon icon="chevron-down" scale="1.5"></b-icon></span>
                    </b-button>
                  </div>
                </b-card-header>
                <b-collapse :id="index" :visible="item.language === $route.params.language" accordion="my-accordion" role="tabpanel">
                  <b-card-body class="bg-light p-0 mt-2">
                    <div class="px-4 py-2">
                      <b-form-group label="ブログタイトル" id="language" class="mb-4">
                        <b-col class="p-0">
                          <b-form-input v-model="item.title" @input="editPen($event, index, blogList.blog_categories)" class="form-input" value="タイトルタイトルタイトルタイトルタイトルタイトルタイトル"></b-form-input>
                        </b-col>
                      </b-form-group>
                      <b-form-group label="ブログ本文" id="blog-body">
                        <b-col class="d-flex align-items-center py-2 px-0 button-editable">
                        </b-col>
                        <b-col class="p-0">
                          <Editor v-model="item.body" :api-key="getTinyConfig.api_key" :init="getTinyConfig.config" cloud-channel="7" />
                        </b-col>
                      </b-form-group>
                    </div>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
           </b-form>
        </b-container>
       </div>
       <div class="d-flex justify-content-between align-items-center mb-4">
         <a href="#scroll" v-smooth-scroll><b-button class="py-3 px-5" variant="primary" @click="blogUpdate">保存</b-button></a>
         <b-button class="py-3 px-5" variant="danger" v-b-modal.modal-delete>削除</b-button>
       </div>
        <b-modal id="modal-delete" ref="modal-delete" class="del-member" hide-footer hide-header centered title="BootstrapVue">
          <h6 class="m-4 text-center">本当に削除してもよろしいですか？</h6>
          <div class="d-flex justify-content-center align-items-center">
            <b-button class="py-3 px-5 mr-3" variant="primary" @click="hideModal">キャンセル</b-button>
            <b-button class="py-3 px-5" variant="danger" v-b-modal.modal-delete @click="delete_blog">削除</b-button>
          </div>
        </b-modal>
     </div>
   </div>
 </div>
</template>

<script>
import { required, requiredIf, minLength } from 'vuelidate/lib/validators'
import sidebar from '@/components/_sidebar/sidebar'
import { mapState, mapActions } from 'vuex'
import Editor from '@tinymce/tinymce-vue'
import appConfig from '../../api/api'
import { blogCategories } from '../../assets/data/values'

export default {
  data () {
    return {
      categories: 'a',
      draft: [],
      languages: null,
      en_lang: false,
      ja_lang: false,
      tw_lang: false,
      cn_lang: false,
      blogImage: null,
      status: [],
      category: blogCategories.map(v => { return { value: v, text: this.$i18n.t(v) } }),
      language: [
        { value: null, text: '選択して下さい', disabled: true },
        { value: 'name_ja', text: '日本語' },
        { value: 'name_en', text: '英語' },
        { value: 'name_zh-cn', text: '簡体字' },
        { value: 'name_zh-tw', text: '繁体字' }
      ],
      error: null,
      response: null
    }
  },
  validations: {
    blogList: {
      administrative_title: {
        required,
        minLength: minLength(5)
      }
    },
    blogImage: {
      required: requiredIf(function () {
        // 編集時点で既存のアイキャッチ画像がある場合は必須チェックをしない
        return this.blogList && !this.blogList.blog_images
      })
    }
  },
  components: {
    sidebar,
    Editor
  },
  computed: {
    ...mapState('adminBlog', ['blogList']),
    ...mapState(['apiStatus']),
    getTinyConfig: function () {
      return appConfig
    },
    imageUrl: function () {
      if (this.blogList.blog_images.images !== null) {
        return this.blogList.blog_images.images.url
      } else {
        return 'ファイルを選択してください'
      }
    },
    validateBlogImageState: function () {
      const { $dirty, $error } = this.$v.blogImage
      return $dirty ? !$error : null
    }
  },
  methods: {
    ...mapActions('adminBlog', ['getBlogSpecific', 'updateStatus', 'updateBlog', 'deleteBlog']),
    validateState (name) {
      const { $dirty, $error } = this.$v.blogList[name]
      return $dirty ? !$error : null
    },
    updateImage: function ($event) {
      this.blogImage = event.target.files[0]
    },
    selectLanguage: function (keys, e) {
      switch (keys) {
        case '日本語':
          if (e === true) {
            this.status = { status: 'published', language: 'name_ja' }
          } else {
            this.status = { status: 'draft', language: 'name_ja' }
          }
          break
        case '英語':
          if (e === true) {
            this.status = { status: 'published', language: 'name_en' }
          } else {
            this.status = { status: 'draft', language: 'name_en' }
          }
          break
        case '簡体字':
          if (e === true) {
            this.status = { status: 'published', language: 'name_zh-cn' }
          } else {
            this.status = { status: 'draft', language: 'name_zh-cn' }
          }
          break
        case '繁体字':
          if (e === true) {
            this.status = { status: 'published', language: 'name_zh-tw' }
          } else {
            this.status = { status: 'draft', language: 'name_zh-tw' }
          }
          break
        default:
          break
      }
      this.updateStatus(this.status)
    },
    activeLanguage: function () {
      switch (this.$route.params.language) {
        case 'ja':
          return (this.ja_lang = true)
        case 'en':
          return (this.en_lang = true)
        case 'cn':
          return (this.cn_lang = true)
        case 'tw':
          return (this.tw_lang = true)
      }
    },
    editPen: function (value, index, exists) {
      switch (index) {
        case '日本語':
          if (value.length > 0 && this.blogList.blog_categories.name_ja !== 'published') {
            this.status = { status: 'draft', language: 'name_ja' }
          }
          break
        case '英語':
          if (value.length > 0 && this.blogList.blog_categories.name_en !== 'published') {
            this.status = { status: 'draft', language: 'name_en' }
          }
          break
        case '簡体字':
          if (value.length > 0 && this.blogList.blog_categories['name_zh-cn'] !== 'published') {
            this.status = { status: 'draft', language: 'name_zh-cn' }
          }
          break
        case '繁体字':
          if (value.length > 0 && this.blogList.blog_categories['name_zh-tw'] !== 'published') {
            this.status = { status: 'draft', language: 'name_zh-tw' }
          }
          break
        default:
          break
      }
      this.updateStatus(this.status)
    },
    blogUpdate: function () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.error = 'エラー：すべてのフィールドを確認して、再試行してください'
      } else {
        const data = { data: this.blogList, id: this.$route.params.id, newImage: this.blogImage }
        this.updateBlog(data)
        this.$nextTick(() => {
          this.$v.$reset()
        })
        this.error = null
      }
    },
    delete_blog: function () {
      this.deleteBlog(this.$route.params.id)
    },
    hideModal () {
      this.$refs['modal-delete'].hide()
    },
    statusAlert (append = false) {
      this.$bvToast.toast('body', {
        title: this.apiStatus,
        toaster: 'b-toaster-top-center',
        solid: true,
        appendToast: append,
        autoHideDelay: 3000
      })
    }
  },
  created () {
    this.getBlogSpecific(this.$route.params.id)
    this.activeLanguage()
  }
}
</script>
